import { IPageFilter } from "../../store/queries/page-filter.interface";
import { createSelector } from "reselect";
import { Job } from "./job.model";
import { JobStatus } from "../job-status/job-status.model";
import { JobType } from "../job-type/job-type.model";
import { getFilterByPropertyFn, getFilterBySearchTermFn } from "../../../core/util/search-and-sort";
import { getSortByFn } from "../../../core/util/utils";
import { IJobFilters } from "./job.reducer";
import { Field } from "../field/field.model";
import { Control } from "../control/control.model";
import { itemSelector, listSelector, Qry } from "../query-facade";
import { VasState } from "../../store/store-type";
import { composeSortByFn } from "../../../core/util/compose-sort-by-fn";
import { isDefined } from "ionic-angular/util/util";

export class JobPageFilter implements IPageFilter<Job, IJobFilters> {

    constructor(protected qry: Qry) {

    }

    createSelector(itemsSelector: listSelector<Job>, filterSelector: itemSelector<IJobFilters>): (state: VasState) => Array<Job> {
        return createSelector(
            this.qry.job.byActiveAccountInlined,
            filterSelector,
            this.controlsByActiveAccount,
            this.jobTypeEntities,
            this.jobStatusEntities,
            (jobs: Array<Job>, filters: IJobFilters, controls: Array<Control>, jobTypeEntities: { [id: string]: JobType }, jobStatusEntities: { [id: string]: JobStatus }) => {
                return jobs
                // user filters
                    .filter(getFilterBySearchTermFn(filters.searchTerm))
                    .filter(getFilterByPropertyFn("jobStatus", filters.jobStatus))
                    .filter(getFilterByPropertyFn("jobType", filters.jobType))
                    // sort
                    .sort(
                        composeSortByFn(
                            getSortByFn(filters.sortBy, filters.sortDirection, (sortBy: string, job: Job) => {
                                switch (sortBy) {
                                    case "reference":
                                    case "jobDate":
                                    case "created":
                                    case "modified":
                                    case "serverCreated":
                                    case "serverModified":
                                        return job[sortBy];
                                    case "fields.registration":
                                        return this._getFieldValueByControlName2(job.fields, sortBy, controls);
                                    case "jobType":
                                        return jobTypeEntities[job.jobType].title;
                                    case "jobStatus":
                                        return jobStatusEntities[job.jobStatus].sequence;
                                    default:
                                        return 1;
                                }
                            }),
                            (a: Job, b: Job) => a.id.localeCompare(b.id)
                        )
                    );
            });
    }

    protected controlsByActiveAccount(state: VasState): Array<Control> {
        return state.control.ids
            .map(id => state.control.entities[id])
            .filter(control => control.account === state.account.selected);
    }

    protected jobTypeEntities(state: VasState): {[id: string]: JobType} {
        return state.jobType.entities;
    }

    protected jobStatusEntities(state: VasState): {[id: string]: JobStatus} {
        return state.jobStatus.entities;
    }

    private _getFieldValueByControlName2 = (fields: Array<Field>, controlName: string, controls: Array<Control>): any => {
        return controls
            .filter(control => control.name === controlName)
            .map(control => fields.find(field => field.id === control.id))
            .map(field => {
                if (!isDefined(field)) {
                    return "";
                }
                return field.value;
            })
            .pop();
    };
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/job/job.page-filter.ts